// import node module libraries
import { Link } from 'react-router-dom';
import { ProgressBar } from 'react-bootstrap';

// import translation
import { useTranslation } from 'react-i18next';

const ConfigurationStepWithProgress = (props) => {
	const { t } = useTranslation();
	const { title, subtitle, onClick, progress, progressVariant } = props;

	return (
		<div className="d-flex justify-content-between my-4 mx-4" style={{ minHeight: '100px', position: 'relative', height: '90%' }}>
			<div className="w-100 h-100 d-flex flex-column justify-content-between flex-grow-1" style={{ height: '100%' }}>
				<div className="flex-grow-1 d-flex flex-column justify-content-between" style={{ height: '100%' }}>
					<div>
						<h2 className="mb-0">{title}</h2>
						<p className="mb-0">{subtitle}</p>
					</div>
					<div className="mt-auto">
						<Link onClick={onClick} className="">
							{t('Configure')}<i className="fe fe-arrow-right ms-1"></i>
						</Link>
						<ProgressBar
							className="flex-auto mt-2"
							style={{ height: '6px' }}
						>
							<ProgressBar variant={progressVariant} now={progress} />
						</ProgressBar>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfigurationStepWithProgress;
